export const colors = {
  // Bright magic-purple accent (#5D3FF6). Distinct from legacy `purple` (#685EDB).
  magicPurple: {
    25: '#EFF0FE',
    50: '#E5E4FD',
    100: '#CCC9FB',
    200: '#B3AEF9',
    300: '#9A93F7',
    400: '#7B6FF8',
    500: '#5D3FF6',
    600: '#4A30E0',
    700: '#3F2BC4',
    800: '#2E2090',
    900: '#1E1560',
    // Magenta-tinted lavender used as the "added" success-banner surface;
    // deliberately warmer than the blue-leaning numeric ramp above.
    successSubtle: '#EDE1ED',
  },
  ink: {
    strong: '#1A1A1A',
    soft: '#3A3A3A',
    muted: '#7A7775',
  },
  // Positive "in sync / auto-updating" green (e.g. the SYNCS destination badge).
  // Darkened to clear WCAG AA (5.0:1 on white) for 12px bold label text.
  sync: '#0D8049',
  line: {
    DEFAULT: 'rgba(0,0,0,0.08)',
    soft: 'rgba(0,0,0,0.04)',
    panel: 'rgba(70,60,120,0.13)',
    card: 'rgba(70,60,120,0.10)',
  },
  surface: {
    panel: '#F4F3FB', // color-mix(#5D3FF6 4%, #F7F7F7) pre-resolved
    card: '#FFFFFF',
  },
  gradients: {
    magic: {
      text: 'linear-gradient(to right, #685EDB, #D5257C)',
    },
  },
  // Destructive red scale (colorScheme="destructive"). The canonical
  // delete-action red (#B73022) is at .500 so it lines up with Chakra's
  // solid/outline shade conventions; .50 is a light tint for hover/active
  // surfaces. Use destructive.50 for tinted backgrounds, destructive.500 for
  // foreground/text on destructive controls.
  destructive: {
    50: '#FCEBE9',
    100: '#F8D5CF',
    200: '#EFAA9F',
    300: '#E27E6E',
    400: '#D05541',
    500: '#B73022',
    600: '#9A2A1D',
    700: '#7C2217',
    800: '#5E1A12',
    900: '#40110C',
  },
  brand: {
    40: '#fae5f0',
    50: '#f3bad6',
    100: '#eb8ebc',
    200: '#e878af',
    300: '#e463a3',
    400: '#e04d96',
    500: '#D5257C',
    600: '#aa1d63',
    700: '#941a56',
    800: '#7e1649',
    900: '#530e30',
  },
  gray: {
    50: '#fbfbfb',
    100: '#f3f3f3',
    200: '#e6e6e6',
    300: '#d9d9d9',
    400: '#cccccc',
    500: '#b3b3b3',
    600: '#9a9a9a',
    700: '#8d8d8d',
    800: '#808080',
    900: '#666666',
  },
  purple: {
    25: '#F7F0FF',
    50: '#F1EEF9',
    100: '#E3DEF2',
    200: '#C9C3FB',
    300: '#AEA5F9',
    400: '#9387F7',
    500: '#685EDB',
    600: '#5349AF',
    700: '#3E3583',
    800: '#2A2258',
    900: '#15112C',
  },
  customgray: {
    bglight: '#F7F8FA',
    lightest: '#F4F4F4',
    light: '#e5e5e5',
    alsolight: '#b5b6b5',
    itsalildark: '#9E9E9E',

    gray: '#E7E7E7',
    mid: '#9A9A9A',
    middark: '#555555',
    dark: '#464646',
    darker2: '#3C3C3C',
    darker: '#313131',
    alsodarker: '#2D2D2D',
    textdark: '#222222',
    evendarker: '#1E1E1E',
  },
  yellow: {
    50: '#fffaeb',
    100: '#fff4d6',
    200: '#ffe9ad',
    300: '#ffdd80',
    400: '#ffcd42',
    500: '#ffc21a',
    600: '#e6a800',
    700: '#b88700',
    800: '#8f6900',
    900: '#5c4300',
  },
  dark: {
    50: '#959388',
    100: '#7b796e',
    200: '#6e6c62',
    300: '#605f56',
    400: '#53514a',
    500: '#383732',
    600: '#1d1d1a',
    700: '#100f0e',
    800: '#020202',
    900: '#000000',
  },
};
